var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flash-message"},[_c('Transition',{attrs:{"name":"flash"}},[(_vm.message)?_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content"},[_c('Icon',{staticClass:"mr-2 inline-block size-5",class:{
                        'star-pulse text-point-yellow':
                            _vm.icon === _vm.IconEnums.POINT,
                    },attrs:{"icon":_vm.icon}}),_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.message.text))])],1)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }